export default () => {
    // Define the pattern to match
    const pattern = /\[(\d+)/; // Matches strings like "[123"
    // Select all elements on the page
    const elements = document.body.getElementsByTagName('*');

    const contentToReplace: {
        element: Element;
        content: string;
    }[] = [];

    // Loop through the elements
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const textNodes = element.childNodes;
        for (let i = 0; i < textNodes.length; i++) {
            const node = textNodes[i];
            if (
                node.nodeType === Node.TEXT_NODE &&
                node.nodeValue &&
                pattern.test(node.nodeValue)
            ) {
                const content = element.innerHTML;
                const contentPattern = /\[(\d+)[^\]]*\]/g;
                const contentWithLinks = content.replace(
                    contentPattern,
                    (match, number) => {
                        return `<a href="/about/references.html#${number}" target="_blank">${match}</a>`;
                    },
                );

                contentToReplace.push({
                    element,
                    content: contentWithLinks,
                });
            }
        }
    }

    contentToReplace.forEach(o => {
        o.element.innerHTML = o.content;
    });
};
